import { createContext } from 'react'

import { getCookie, removeCookies } from 'cookies-next'

import mixpanelTrack from 'lib/mixpanel-track'
import toString from 'lodash/toString'

export const Context = createContext<string | undefined>(undefined)
Context.displayName = 'TokenContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const TokenContext = ({ children }: Props) => {
  const value = toString(getCookie('access_token')) || undefined

  if (toString(getCookie('mixpanel_need_to_track_login'))) {
    mixpanelTrack('login')
    removeCookies('mixpanel_need_to_track_login')
  }

  return <Provider value={value}>{children}</Provider>
}

export default TokenContext
